import 'jquery-ui-dist/jquery-ui.min.js'
import moment from 'moment';
import '@fancyapps/fancybox';

const dailyFeedingCalculator = {};

const debug = {
    log: (msg) => {
        if (process.env.NODE_ENV === 'development')
            console.log(msg);
    }
};

(function (dailyFeedingCalculatorApp) {
    let currentWeightInput = null;
    let dobInput = null;
    let feedingCalculatorSelector = null;
    let formDirtyFlag = false;

    let filterModel = {
        ProductId: 0,
        CurrentWeight: 0,
        ActivityLevel: null,
        ActivityFactor: 0,
        DateOfBirth: null,
        ExpectedAdultWeight: 0,
        TransitionToAdultFood: false,
        IsRecommendedDropdownProduct: false,
        RecommendBreedSizeSpecificProducts: false,
        BreedSize: null,
        IsStandAloneFeedingCalculator: false,
        IsTransittedFromProductCalculator: false,
        MaximumWetFoodPouchPerDay: 0,
    }
    let isStandAloneFeedingCalculator = false;
    let productSelectedImage = null;
    let isPuppyFood = false;
    let isTransittedFromProductCalculator = false;
    let transittedAdultFromProductCalculator = false;
    let transittedBreedSizeFromProductCalculator = false;
    let isAdult, isCat, isAdultCat, isDog, isPuppy = false;
    let isdryfoodproduct = true;
    let isAllBreeds = false;
    const puppyWetFoodAvailable = () => feedingCalculatorSelector.data("puppywetfoodisavailable");


    dailyFeedingCalculatorApp.GetResults = function () {
        filterModel.PetType = feedingCalculatorSelector.data("pettype");
        filterModel.LifeStage = isAdult ? "adult" : (isPuppy ? "puppy" : "kitten");
        filterModel.FoodCombination = $("#js-feeding-combination").val();

        if (!puppyWetFoodAvailable() && isPuppy && isdryfoodproduct && !isStandAloneFeedingCalculator) {
            filterModel.FoodCombination = "dry";
        }

        $.ajax({
            url: "/umbraco/surface/DailyFeedingCalculatorSurface/GetResult",
            type: "GET",
            data: filterModel,
            dataType: "html",
            success: function (data) {
                $(".js-feeding-calculator-results").html(data);
                $('.js-fc-cta').fancybox({
                    iframe: {
                        css: {
                            'width': 800,
                            'height': 600,
                            'max-width': '95%',
                            'max-height': '95%'
                        }
                    }
                });
                document.querySelector('.js-feeding-calculator-results').scrollIntoView({ behavior: "smooth", block: isStandAloneFeedingCalculator ? "start" : "center", inline: "nearest" });
            },
            error: function (xhr, status, error) {
                console.log(status);
                console.log(xhr.status + " - " + error);
            }
        });
    };

    function initializeInputSelectors() {
        currentWeightInput = $(".js-current-weight");
        dobInput = $(".js-dob");
        feedingCalculatorSelector = $(".js-feeding-calculator");
        isStandAloneFeedingCalculator = feedingCalculatorSelector.data("isfeedingcalculatordetail");
        productSelectedImage = $("#product-selected-image");

        const transittedFromProductCalculator = feedingCalculatorSelector.data("transittedfromproductcalculator") ?? "";
        transittedAdultFromProductCalculator = transittedFromProductCalculator == "transitted-adult";
        transittedBreedSizeFromProductCalculator = transittedFromProductCalculator == "transitted-breedsize";
        isTransittedFromProductCalculator = transittedAdultFromProductCalculator || transittedBreedSizeFromProductCalculator;
    }

    function roundCurrentWeight() {
        var currentWeight = $(".js-current-weight").length > 1 ? $(".js-current-weight").eq(1).val() : currentWeightInput.val();

        if (isNaN(currentWeight) || currentWeight < 0) {
            currentWeightInput.val(0);
            return;
        }

        //round to nearest 0.5
        const roundedWeight = (Math.round(currentWeight * 2) / 2).toFixed(1);
        currentWeightInput.val(roundedWeight);

        if (isCat && roundedWeight > 20) {
            $("#cw-validation").css("display", "block");
            $("#cw-validation").html("Please check the weight that you have entered. We can only support calculations for cats that weigh up to 20kg.");
        } else {
            $("#cw-validation").css("display", "none");
        }
    }

    function handleFeedingCalculatorDetailDob() {
        const dateObject = moment($(".datepicker").val()).toDate();
        const now = moment(new Date());
        const end = moment(dateObject);

        if (!isCat) {
            const months = now.diff(end, 'months');
            $(".js-pet-food-products-section").css("display", "block");
            //if DOB selected by user is less than 22 months, then display Adult Dog food and Puppy Food buttons
            if (months < 22) {
                isAdult = false;
                $(".js-current-pet-food-section").css("display", "block");

            } else {
                //if DOB selected by user is 22 months or more, then select adult and hide options
                $(".js-current-pet-food-section").css("display", "none");
                $(".js-current-pet-food-dog").prop("checked", true);
                isAdult = true;
            }
        }
        else {
            const days = now.diff(end, 'days');
            const newLifeStage = days >= 365;
            if (newLifeStage != isAdultCat) {
                $("#js-feeding-combination").val("-1");
                $(".js-products-cat").val("-1");
                isAdultCat = newLifeStage;
                isAdult = newLifeStage;
            }
        }

        updateFeedingCalculatorDetailSections();
    }

    function updateFeedingCalculatorDetailSections() {

        isdryfoodproduct = feedingCalculatorSelector.data("isdryfoodproduct") && feedingCalculatorSelector.data("isdryfoodproduct").toLowerCase() === "true";
        let feedingCombination = $("#js-feeding-combination").val();


        if (!isCat) {
            if ($(".js-current-pet-food-section").length > 0) {
                const petFoodRadio = $(".js-current-pet-food-section input[type='radio']:checked");
                if (petFoodRadio.length != 1 && !isTransittedFromProductCalculator && isStandAloneFeedingCalculator) return;

                const id = petFoodRadio.attr("id");
                isPuppyFood = id == "puppy-food";

                isAdult = !isPuppyFood;
                isPuppy = isPuppyFood;
            }

            if (isTransittedFromProductCalculator) {
                isPuppyFood = !transittedAdultFromProductCalculator;
            }

            if (isPuppyFood || isPuppy) {
                $(".js-feeding-combination-section").show();
                $(".js-adult-pet-current-weight-section").css("display", "none");
                $(".js-dog-activity-level-section:not(.transitted)").css("display", "none");
                $(".js-dog-activity-level-section:not(.transitted)").css("display", "none");
                $(".js-puppy-section").css("display", "block");
                $("label[for='js-products']").html("Please select one of our puppy dry foods.");

                if (!puppyWetFoodAvailable() && (isdryfoodproduct || isStandAloneFeedingCalculator)) {
                    feedingCombination = "dry";
                }

                var showLargeBreedDryFoodOnly = filterModel.ExpectedAdultWeight >= 50
                    && (isdryfoodproduct || isStandAloneFeedingCalculator)
                    && (isAllBreeds || isStandAloneFeedingCalculator)
                    && isDog;

                if (showLargeBreedDryFoodOnly) {
                    feedingCombination = "dry";
                    $("#js-feeding-combination").val(feedingCombination).trigger('change');
                    $(".js-feeding-combination-section").hide();
                    $(".js-pet-food-products-section").show();
                    $(".js-pet-food-products-section").show();
                    $("label[for='js-products']").show();
                    $("#js-products").show();
                    $("label[for='js-products-wet']").hide();
                    $("#js-products-wet").hide();
                }

                $("#js-products option").hide();
                $("#js-products option[data-allbreeds='true']").show();
                if (filterModel.ExpectedAdultWeight >= 30) {
                    $("#js-products option[data-type='large-puppy']").show();
                }
                if (filterModel.ExpectedAdultWeight >= 15 && filterModel.ExpectedAdultWeight <= 30) {
                    $("#js-products option[data-type='medium-puppy']").show();
                }
                if (filterModel.ExpectedAdultWeight <= 15) {
                    $("#js-products option[data-type='small-puppy']").show();
                }

                if (feedingCombination == "-1") {
                    $(".js-pet-food-products-section").hide();
                } else {
                    if (!isStandAloneFeedingCalculator) {
                        if (!showLargeBreedDryFoodOnly && feedingCombination === "dry") {
                            $(".js-pet-food-products-section").hide();
                        }

                        if (feedingCombination === "dryandwet") {
                            $(".js-pet-food-products-section").show();

                            //if (isPuppy) {
                            $("label[for='js-products']").css("display", isdryfoodproduct ? "none" : "block");
                            $("#js-products").css("display", isdryfoodproduct ? "none" : "block");
                            //} else {
                            //    $("label[for='js-products-dry']").css("display", isdryfoodproduct ? "none" : "block");
                            //    $("#js-products-dry").css("display", isdryfoodproduct ? "none" : "block");
                            //}

                            $("label[for='js-products-wet']").css("display", isdryfoodproduct ? "block" : "none");
                            $("#js-products-wet").css("display", isdryfoodproduct ? "block" : "none");

                        }
                    } else { // standalone calculator
                        $(".js-pet-food-products-section").show();
                        $("label[for='js-products']").show();
                        $("#js-products").show();

                        $("label[for='js-products-wet']").show();
                        $("#js-products-wet").show();

                        if (showLargeBreedDryFoodOnly || !puppyWetFoodAvailable()) {
                            $("label[for='js-products']").show();
                            $("#js-products").show();

                            $("label[for='js-products-wet']").hide();
                            $("#js-products-wet").hide();
                        }


                    }
                }

                if (!puppyWetFoodAvailable() && (isdryfoodproduct || isStandAloneFeedingCalculator)) {
                    feedingCombination = "dry";
                    $("#js-feeding-combination").off('change');
                    $("#js-feeding-combination").val(feedingCombination);
                    $("#js-feeding-combination").on('change', onFeedCombinationChanged);
                    $(".js-feeding-combination-section").hide();
                }
            } else {
                //show adult food calculator
                $(".js-feeding-combination-section").hide();
                $(".js-adult-pet-current-weight-section").css("display", "block");
                $(".js-dog-activity-level-section:not(.transitted)").css("display", "none");
                $(".js-puppy-section").css("display", "none");
                $("#js-products option[data-type='adult']").show();
                $("#js-products option[data-type$='-puppy']").hide();
                $(".js-pet-food-products-section").show();
                $("label[for='js-products']").show();
                $("#js-products").show();
                $("label[for='js-products']").html("Please select one of our adult dog foods.");
                $("label[for='js-products-wet']").hide();
                $("#js-products-wet").hide();
            }
            $("#js-products").val(-1);
        } else { // is cat
            if (feedingCombination == "-1") {
                $(".js-pet-food-products-section").hide();
            } else {
                if (!isStandAloneFeedingCalculator) {
                    $(".js-pet-food-products-section").hide();
                    if (feedingCombination == "dryandwet") {
                        $(".js-pet-food-products-section").css("display", "block");
                        $("label[for='js-products-dry']").css("display", isdryfoodproduct ? "none" : "block");
                        $("#js-products-dry").css("display", isdryfoodproduct ? "none" : "block");
                        $("label[for='js-products-wet']").css("display", isdryfoodproduct ? "block" : "none");
                        $("#js-products-wet").css("display", isdryfoodproduct ? "block" : "none");
                    }
                } else {
                    $(".js-pet-food-products-section").show();
                }
            }

            $(".js-adult-pet-current-weight-section").css("display", isAdultCat || !isStandAloneFeedingCalculator ? "block" : "none");
        }
    }

    function initializeSlider(weightSlider) {
        if (weightSlider.length) {
            //non-linear slider. uses index of slider and valMap
            const expectedAdultWeights = $(weightSlider).next("ul.ui-slider-labels").children().map(function () {
                return $(this).text();
            }).get();
            let startIndex = 5;
            filterModel.ExpectedAdultWeight = expectedAdultWeights[startIndex];

            if (isTransittedFromProductCalculator && transittedBreedSizeFromProductCalculator && weightSlider.data("weight") != undefined) {
                const weight = weightSlider.data("weight");
                filterModel.ExpectedAdultWeight = weight;
                startIndex = expectedAdultWeights.indexOf(weight.toString());
                if (startIndex < 0) startIndex = 5;
            }

            weightSlider.slider({
                min: 0,
                max: expectedAdultWeights.length - 1,
                value: startIndex,
                range: "min",
                slide: function (event, ui) {
                    //update filterModel on slide
                    filterModel.ExpectedAdultWeight = expectedAdultWeights[ui.value];
                    currentWeightInput.val(expectedAdultWeights[ui.value]);
                    //debug.log('expected adult weight: ' + expectedAdultWeights[ui.value]);
                    updateFeedingCalculatorDetailSections();
                }
            });
        }
    }

    function initializeMaximumWetFoodSlider(slider) {
        if (slider.length) {
            //non-linear slider. uses index of slider and valMap
            const maximumWetFoodPerDay = $(slider).next("ul.ui-slider-labels").children().map(function () {
                return $(this).text();
            }).get();
            let startIndex = 1;
            filterModel.MaximumWetFoodPouchPerDay = maximumWetFoodPerDay[startIndex];

            if (isTransittedFromProductCalculator && transittedBreedSizeFromProductCalculator && slider.data("weight") != undefined) {
                const weight = slider.data("weight");
                filterModel.MaximumWetFoodPouchPerDay = weight;
                startIndex = maximumWetFoodPerDay.indexOf(weight.toString());
                if (startIndex < 0) startIndex = 5;
            }

            slider.slider({
                min: 0,
                max: maximumWetFoodPerDay.length - 1,
                value: startIndex,
                range: "min",
                slide: function (event, ui) {
                    //update filterModel on slide
                    filterModel.MaximumWetFoodPouchPerDay = maximumWetFoodPerDay[ui.value];
                    //debug.log('expected adult weight: ' + maximumWetFoodPerDay[ui.value]);
                    /*currentWeightInput.val(maximumWetFoodPerDay[ui.value]);*/
                    updateFeedingCalculatorDetailSections();
                }
            });
        }
    }

    function formIsValid() {
        let isValid = true;
        initializeInputSelectors();
        const hasDob = isPuppy || isCat;
        const currentWeight = currentWeightInput.val();
        const productValidation = $(".js-transition-products").val();

        $("#cw-validation").css("display", "none");
        $("#dob-validation").css("display", "none");
        $("#product-validation").css("display", "none");
        $("#product-selector-validation").css("display", "none");

        if (!isCat) {
            if (currentWeight === "" || currentWeight <= 0) {
                if (!isStandAloneFeedingCalculator || (isStandAloneFeedingCalculator && !isPuppyFood)) {
                    $("#cw-validation").css("display", "block");
                    isValid = false;
                }
            }
        }

        if (hasDob) {
            if (!moment(dobInput.val()).isValid()) {
                $("#dob-validation").css("display", "block");
                isValid = false;
            }
        }

        if (productValidation === "") {
            $("#product-validation").css("display", "block");
            isValid = false;
        }

        if (isStandAloneFeedingCalculator && $("#js-products").val() == -1) {
            $("#product-selector-validation").css("display", "block");
            isValid = false;
        }

        if (isCat || isPuppy) {
            if (isAdultCat) {
                if (currentWeight === "" || currentWeight <= 0) {
                    $("#cw-validation").html("Please enter your cat's current weight");
                    $("#cw-validation").css("display", "block");
                    isValid = false;
                } else {
                    if (currentWeight > 20) {
                        $("#cw-validation").css("display", "block");
                        $("#cw-validation").html("Please check the weight that you have entered. We can only support calculations for cats that weigh up to 20kg.");
                        isValid = false;
                    } else {
                        $("#cw-validation").css("display", "none");
                        $("#cw-validation").html("Please enter your cat's current weight");
                    }
                }
            }

            const feedingCombination = $("#js-feeding-combination").val();
            const isDryFoodOnly = $("#js-feeding-combination").val() == "dry";
            const isWetFoodOnly = $("#js-feeding-combination").val() == "wet"
            const isDryFoodProductNotSelected = isPuppy ? $("#js-products").val() == -1 : $("#js-products-dry").val() == -1;
            const isWetFoodProductNotSelected = $("#js-products-wet").val() == -1;

            if (feedingCombination == -1) {
                isValid = false;
                $("#product-selector-validation-combination").css("display", "block");
            } else {
                $("#product-selector-validation-combination").css("display", "none");
            }

            if (isStandAloneFeedingCalculator) {
                if (isDryFoodProductNotSelected && !isWetFoodOnly) {
                    isValid = false;
                    $("#product-selector-validation-dry").css("display", "block");
                } else {
                    $("#product-selector-validation-dry").css("display", "none");
                }
                if (isWetFoodProductNotSelected && !isDryFoodOnly) {
                    isValid = false;
                    $("#product-selector-validation-wet").css("display", "block");
                } else {
                    $("#product-selector-validation-wet").css("display", "none");
                }
            } else {
                if (isWetFoodProductNotSelected && isdryfoodproduct && feedingCombination === "dryandwet") {
                    isValid = false;
                    $("#product-selector-validation-wet").css("display", "block");
                } else {
                    $("#product-selector-validation-wet").css("display", "none");
                }
                if (isDryFoodProductNotSelected && !isdryfoodproduct && feedingCombination === "dryandwet") {
                    isValid = false;
                    $("#product-selector-validation-dry").css("display", "block");
                    $("#product-selector-validation").css("display", "block");
                } else {
                    $("#product-selector-validation-dry").css("display", "none");
                }
            }
        }

        const hasActivityLevel = $(".pet-activity-levels:visible input[type='radio']:visible").length > 0;
        if (hasActivityLevel) {
            const isValidActivityLevel = $(".pet-activity-levels:visible input[type='radio']:visible:checked").length > 0;
            $(".js-pet-activity-validation").css("display", isValidActivityLevel ? "none" : "block");
            isValid = isValidActivityLevel;
        }

        return isValid;
    }

    function disableSubmitButtonAndSetCursorState(disabled) {
        const cursorType = disabled ? 'wait' : 'auto';

        $("#sendEmail").prop('disabled', disabled);
        $("body").css('cursor', cursorType);
    }

    function updateActivityLevelDataForCat(activityLevelsData) {
        if (activityLevelsData.split(",").length > 1) {
            $(".js-cat-activity-level-section").css("display", "block");
        } else {
            $(".js-cat-activity-level-section").css("display", "none");
        }
        let toolTipsContent = "";
        if (activityLevelsData != undefined && activityLevelsData != "") {
            const showedToolTips = [];
            const tooltipsList = ($("#activity-levels-cat-tooltip").val() ?? "").split(";");
            const levels = activityLevelsData.split(",");
            if (levels.length > 1) {
                $("#activity-levels-cat").find('input[type="radio"]').each(function () {
                    const id = $(this).attr("id");
                    if (levels.indexOf(id) < 0) {
                        $(this).closest(".form__row--checkbox").hide();
                    } else {
                        $(this).closest(".form__row--checkbox").show();
                        const toolTipPrefix = `${id}|`;
                        const existingTooltip = tooltipsList.find(x => x.startsWith(toolTipPrefix));
                        if (existingTooltip) {
                            showedToolTips.push(existingTooltip.replace(toolTipPrefix, ""));
                        }
                    }
                })
            }
            toolTipsContent = showedToolTips.join(".<br/>");
        }

        $(".js-cat-activity-level-section .js-tooltip").tooltip("option", "content", toolTipsContent);
        $(".js-pet-activity-validation").css("display", "none");
    }

    function setInitialValues() {
        feedingCalculatorSelector = $(".js-feeding-calculator");

        isdryfoodproduct = feedingCalculatorSelector.data("isdryfoodproduct") && feedingCalculatorSelector.data("isdryfoodproduct").toLowerCase() === "true";
        isAllBreeds = feedingCalculatorSelector.data("isallbreeds") && feedingCalculatorSelector.data("isallbreeds").toLowerCase() === "true";
        isAdult = feedingCalculatorSelector.data("isadult") == true;
        isCat = feedingCalculatorSelector.data("pettype") === "cat" || feedingCalculatorSelector.data("pettype") === "kitten";
        isAdultCat = feedingCalculatorSelector.data("pettype") === "cat"  && isAdult;
        isDog = feedingCalculatorSelector.data("pettype") === "dog"  || feedingCalculatorSelector.data("pettype") === "puppy";
        isPuppy = isDog && !isAdult;

        isPuppyFood = isPuppy;
    }

    function onFeedCombinationChanged () {
        $(".js-cat-activity-level-section").css("display", "none");
        const combination = $(this).val();
        $('.product-image').attr('src', '');

        if (!isStandAloneFeedingCalculator) {
            isAdultCat = feedingCalculatorSelector.data("pettype") === "cat"
                && feedingCalculatorSelector.data("isadult");
        }

        $(".js-pet-food-products-section").css("display", "none");
        if (combination === "-1") {
            $(".js-pet-food-products-section").css("display", "none");
            $("#js-maximum-wet-food-pouch-slider").hide();
            return;
        } else {
            $(".js-pet-food-products-section").css("display", "block");
            $("#product-selector-validation-combination").css("display", "none");
        }

        $("#js-maximum-wet-food-pouch-slider").css("display", combination == "dryandwet" ? "block" : "none");



        const isOnDryFoodProductPage = feedingCalculatorSelector.data("isdryfoodproduct") && feedingCalculatorSelector.data("isdryfoodproduct").toLowerCase() === "true";

        const productsListRequestModel = {
            CurrentWeight: $(".js-current-weight").val(),
            PetType: isDog ? "dog" : "cat",
            FeedingCombination: combination,
            LifeStage: isDog ? (isAdult ? 'adult' : 'puppy') : (isAdult ? 'adult' : 'kitten'),
            IsGeneratedDryFoodProduct: (isStandAloneFeedingCalculator && combination.indexOf('dry') != -1)
                || (!isStandAloneFeedingCalculator && !isOnDryFoodProductPage),
            IsGeneratedWetFoodProduct: (isStandAloneFeedingCalculator && combination.indexOf('wet') != -1) || (!isStandAloneFeedingCalculator && isOnDryFoodProductPage),
        }

        if (!isStandAloneFeedingCalculator && isAdultCat) {
            if (combination != "-1") {

                $(".js-cat-activity-level-section").css("display", "block");
                let activityLevelsData = "";
                switch (combination) {
                    case "dry":
                    case "wet":
                        if (isCat) {
                            activityLevelsData = feedingCalculatorSelector.data("foodproductactivitylevels");
                        }
                        break;
                    case "dryandwet":
                        if (isOnDryFoodProductPage && isCat) {
                            activityLevelsData = feedingCalculatorSelector.data("foodproductactivitylevels");
                        } else {
                            activityLevelsData = $("#js-products-dry").find(":selected")?.data("activity-levels") ?? "";
                        }
                        break;
                }
                updateActivityLevelDataForCat(activityLevelsData);
            }
        }

        $.ajax({
            url: "/umbraco/surface/DailyFeedingCalculatorSurface/GetDailyFeedingCalculatorDetailProductsList",
            type: "GET",
            data: productsListRequestModel,
            dataType: "html",
            success: function (data) {
                $(".js-pet-food-products-section").html(data);
                updateFeedingCalculatorDetailSections();
            },
            error: function (xhr, status, error) {
                console.log(status);
                console.log(xhr.status + " - " + error);
            }
        });
    }

    $(document).ready(function () {
        setInitialValues();
        initializeInputSelectors();
        initializeSlider($(".js-puppy-weight-slider"));
        initializeMaximumWetFoodSlider($(".js-pouch-wet-food-slider"));

        $("#js-feeding-combination")?.val("-1");

        if (isTransittedFromProductCalculator) {
            handleFeedingCalculatorDetailDob();
        }

        $('.js-tooltip').tooltip({
            tooltipClass: "tooltip",
            content: function () {
                return $(this).attr('title');
            },
            close: function (event, ui) {
                //keep tooltip open on tooltip hover
                ui.tooltip.hover(function () {
                    $(this).stop(true).fadeTo(400, 1);
                },
                    function () {
                        $(this).fadeOut('400', function () {
                            $(this).remove();
                        });
                    });
            }
        });

        $(document).on("blur", ".js-current-weight", function () {
            roundCurrentWeight();
        });

        $(document).on("blur", ".js-current-weight", function () {
            if (!isCat && !isStandAloneFeedingCalculator) return;

            let productsListRequestModel = {
                CurrentWeight: $(this).val(),
                PetType: feedingCalculatorSelector.data("pettype"),
                LifeStage: isDog ? (isAdult ? 'adult' : 'puppy') : (isAdult ? 'adult' : 'kitten'),
                TransittedFromProductCalculator: isTransittedFromProductCalculator,
                TransittedToAdult: transittedAdultFromProductCalculator,
                TransittedBreedSize: transittedBreedSizeFromProductCalculator,
                TransittedWeight: $(".js-pet-food-products-section").data("transittedweight")
            }

            if (isCat || isPuppy) {
                if (productsListRequestModel.CurrentWeight > 20 && isCat) {
                    $(".js-feeding-combination-section").css("display", "none");
                    $("#js-feeding-combination").val(-1).trigger('change');
                    return;
                } else {
                    $(".js-feeding-combination-section").css("display", "block");
                }

                $("#js-feeding-combination").val(-1).trigger('change');
                $("#js-maximum-wet-food-pouch-slider").css("display", "none");
            }

            if (productsListRequestModel.CurrentWeight > 0) {
                $.ajax({
                    url: "/umbraco/surface/DailyFeedingCalculatorSurface/GetDailyFeedingCalculatorDetailProductsList",
                    type: "GET",
                    data: productsListRequestModel,
                    dataType: "html",
                    success: function (data) {
                        $(".js-pet-food-products-section").html(data);
                        updateFeedingCalculatorDetailSections();
                    },
                    error: function (xhr, status, error) {
                        console.log(status);
                        console.log(xhr.status + " - " + error);
                    }
                });
            }
        });

        $(document).on("click", ".js-submit", function (e) {
            e.preventDefault();
            submit();
        });

        $(document).on("change", "input[type=radio][name=activity-level].js-transition-activity-level", function () {
            submit();
        });

        function submit() {
            formDirtyFlag = true;
            const selectedActivityLevel = $('input[name="activity-level"]:checked');

            if (!formIsValid()) return;

            filterModel.CurrentWeight = currentWeightInput.val();

            filterModel.ActivityLevel = !$("#activity-levels").is(":visible") ? (!$("#activity-levels-transitted").is(":visible") ? '' : selectedActivityLevel.val()) : selectedActivityLevel.val();
            filterModel.ActivityFactor = selectedActivityLevel.data("acitivityfactor");

            if (!filterModel.IsRecommendedDropdownProduct) {
                if (isStandAloneFeedingCalculator) {
                    filterModel.ProductId = $("#js-products").val();
                } else {
                    filterModel.ProductId = feedingCalculatorSelector.data("productid");
                }
            } else {
                if (isStandAloneFeedingCalculator) {
                    if (isPuppyFood) {
                        filterModel.ActivityLevel = null;
                        filterModel.ActivityFactor = 0;
                    } else {
                        filterModel.ProductId = $("#js-products").val();
                    }
                }
            }

            if (dobInput.length) {
                if (!isStandAloneFeedingCalculator || (isStandAloneFeedingCalculator && (isPuppyFood || (isCat && !isAdultCat)))) {
                    filterModel.DateOfBirth = moment(new Date(dobInput.val())).format("DD/MM/YYYY");
                }
            }

            filterModel.IsStandAloneFeedingCalculator = isStandAloneFeedingCalculator;

            if (!filterModel.IsRecommendedDropdownProduct && isTransittedFromProductCalculator) {
                filterModel.IsTransittedFromProductCalculator = true;
                if (dobInput.length) {
                    filterModel.DateOfBirth = moment(new Date(dobInput.val())).format("DD/MM/YYYY");
                }
            }

            const combination = $("#js-feeding-combination").val();
            filterModel.DryFoodProductId = combination == "dryandwet" || combination == "dry" ? $("#js-products-dry").val() : $("#js-products").val();
            filterModel.WetFoodProductId = combination == "dryandwet" || combination == "wet" ? $("#js-products-wet").val() : -1;

            if (isPuppy || isPuppyFood) {
                if (!isdryfoodproduct) {
                    filterModel.DryFoodProductId = combination == "dryandwet" || combination == "dry" ? $("#js-products").val() : -1;
                }
            }

            dailyFeedingCalculatorApp.GetResults();
        }

        $(document).on("input", ".js-current-weight, .js-dob", function (event) {
            if (formDirtyFlag) {
                formIsValid();
            }
        });

        $(document).on("keyup", ".js-current-weight, .js-dob", function (event) {
            if (event.keyCode === 13) {
                roundCurrentWeight();
                $(".js-submit").click();
            }
        });

        $(document).on("change", ".js-dob", function () {
            if (!moment(dobInput.val()).isValid()) {
                $("#dob-validation").css("display", "block");
                return;
            } else {
                $("#dob-validation").css("display", "none");
            }

            if (isStandAloneFeedingCalculator) {
                handleFeedingCalculatorDetailDob();
            }

            if (formDirtyFlag) {
                formIsValid();
            }
        });

        $(document).on("click", ".js-fc-product-buy-now", function (e) {
            e.preventDefault();
            $(".js-product-buy-now").click();
        });

        $(document).on("change", ".js-dropdown-products", function () {
            productSelectedImage.attr("src", "");
            filterModel.ProductId = $(this).find(':selected').data('productid');
            filterModel.TransitionToAdultFood = $(this).data('transitiontoadultfood');
            filterModel.RecommendBreedSizeSpecificProducts = $(this).data('recommendbreedsizespecificproducts');
            filterModel.BreedSize = $(this).data('breedsize');
            filterModel.IsRecommendedDropdownProduct = true;
            submit();
        });

        $(document).on("click", "#js-email-result", function (e) {
            if (filterModel.DateOfBirth && filterModel.DateOfBirth !== "") {
                $(".email-pet-dob-row").hide();
            } else {
                $(".email-pet-dob-row").show();
                $("#email-result-dob").val($(".js-dob").val());
            }
        });

        function getFormEmailData() {
            let result = {};
            result.IsValid = true;
            result.PetName = $("#email-pet-name").val();
            result.FirstName = $("#email-first-name").val();
            result.LastName = $("#email-last-name").val();
            result.EmailAddress = $("#email-result").val();

            var isGetDobFromCalculationResult = filterModel.DateOfBirth && filterModel.DateOfBirth !== "";
            result.DateOfBirth = isGetDobFromCalculationResult ? filterModel.DateOfBirth : moment(new Date($("#email-result-dob").val())).format("DD/MM/YYYY");

            $("#email-pet-name-validation").css("display", "none");
            $("#email-first-name-validation").css("display", "none");
            $("#email-last-name-validation").css("display", "none");
            $("#email-pet-dob-validation").css("display", "none");
            $("#email-result-validation").css("display", "none");
            $("#subscribe-option-validation").css("display", "none");

            if (!isGetDobFromCalculationResult) {
                if (result.DateOfBirth === "") {
                    $("#email-pet-dob-validation").css("display", "block");
                    $("#email-pet-dob-validation").text("Please enter date of birth");
                    result.IsValid = false;
                } else if (!moment(result.DateOfBirth, 'DD/MM/YYYY', true).isValid()) {
                    $("#email-pet-dob-validation").css("display", "block");
                    $("#email-pet-dob-validation").text("Invalid date of birth");
                    result.IsValid = false;
                }
            }
            if (result.PetName === "") {
                $("#email-pet-name-validation").css("display", "block");
                result.IsValid = false;
            }
            if (result.FirstName === "") {
                $("#email-first-name-validation").css("display", "block");
                result.IsValid = false;
            }
            if (result.LastName === "") {
                $("#email-last-name-validation").css("display", "block");
                result.IsValid = false;
            }
            if (result.EmailAddress === "") {
                result.IsValid = false;
                $("#email-result-validation").text("Please enter email");
                $("#email-result-validation").css("display", "block");
            } else {
                var emailRegex = /\S+@\S+\.\S+/;
                if (!emailRegex.test(result.EmailAddress)) {
                    result.IsValid = false;
                    $("#email-result-validation").text("Invalid email");
                    $("#email-result-validation").css("display", "block");
                }
            }
            if (!$("#subscribe_option").is(':checked')) {
                $("#subscribe-option-validation").css("display", "block");
                result.IsValid = false;
            }

            if (result.IsValid) {
                result.Weight = $(".js-feeding-calculator .js-current-weight").length > 0 ? filterModel.CurrentWeight : filterModel.ExpectedAdultWeight;
                result.GramsPerDay = $("#GramsPerDay").val();
                result.PetType = $("#PetType").val();
                result.SalesforceName = $("#SalesforceName").length > 0 ? $("#SalesforceName").val() : "";
                result.Protein = $("#Protein").length > 0 ? $("#Protein").val() : "";
                result.IsSubscribed = $("#subscribe_option").is(":checked");
                result.ActivityLevel = filterModel.ActivityLevel ? filterModel.ActivityLevel : "";
            }

            return result;
        }

        $(document).on("submit", "#calculator-email-results form", function (e) {
            e.preventDefault();
            var emailResultData = getFormEmailData();
            if (!emailResultData.IsValid) return;
            disableSubmitButtonAndSetCursorState(true);

            var token = $(this).find('input:hidden[name="__RequestVerificationToken"]').val();
            $("#error-email-result").hide();
            $.ajax({
                url: "/umbraco/surface/DailyFeedingCalculatorSurface/SendEmailResult",
                type: "POST",
                data: emailResultData,
                dataType: "json",
                beforeSend: function (xhr) {
                    xhr.setRequestHeader("RequestVerificationToken", token);
                },
                success: function (result) {
                    disableSubmitButtonAndSetCursorState(false);
                    if (result.success === true) {
                        $("#calculator-email-results input").val("");
                        $("#calculator-email-results .js-emailmyresultsform").hide();
                        $("#calculator-email-results .js-emailmyresultssuccessmessage").show();
                    } else {
                        $("#error-email-result").html(result.error);
                        $("#error-email-result").show();
                    }
                },
                error: function (xhr, status, error) {
                    disableSubmitButtonAndSetCursorState(false);
                    console.log(xhr);
                    console.log(status);
                    console.log(xhr.status + " - " + error);
                    $("#error-email-result").html("Sorry, we could not send your details. Please try again.");
                    $("#error-email-result").show();
                }
            });
        });

        $(document).on("change", ".js-current-pet-food-section input[type='radio']", function (e) {
            $('#js-feeding-combination').val(-1).trigger('change');
            updateFeedingCalculatorDetailSections();
        });

        $(document).on("change", "#js-products", function (e) {
            $("#product-selector-validation").hide();
            $(".feeding-calculator__results-amount").addClass("is-disabled");
            $(".feeding-calculator__results-amount p.h2").text("0g");
            $(".feeding-calculator__results-amount p.label").text("Per day");

            $(".feeding-calculator__results-cost-item").addClass("is-disabled");
            $(".feeding-calculator__results-cost-item.js-cost-per-day p.h3").text("$0.00");
            $(".feeding-calculator__results-cost-item.js-cost-per-bag p.h3").text("$0.00");

            const productId = $(this).val();
            if (productId == -1) {
                productSelectedImage.attr("src", "");
                $("#activity-levels-transitted").css("display", "none");
                $(".js-dog-activity-level-section:not(.transitted)").css("display", "none");
            } else {
                if ($("#js-products :selected").data("activity-levels").split(",").length > 1) {
                    $(".js-dog-activity-level-section:not(.transitted)").css("display", "block");
                } else {
                    $(".js-dog-activity-level-section:not(.transitted)").css("display", "none");
                }

                const imgSrc = $("#js-products :selected").data("product-selected-image");
                $("#product-selected-image").attr("src", imgSrc);

                const activityLevelsData = $("#js-products :selected").data("activity-levels");
                if (activityLevelsData != undefined && activityLevelsData != "") {
                    const levels = activityLevelsData.split(",");
                    if (levels.length > 1) {
                        let activityLevelsContainer = $("#activity-levels");
                        if (isTransittedFromProductCalculator) {
                            activityLevelsContainer = $("#activity-levels-transitted");
                            activityLevelsContainer.css("display", "block");
                        }
                        activityLevelsContainer.find('input[type="radio"]').each(function () {
                            const id = $(this).attr("id");
                            if (levels.indexOf(id) < 0) {
                                $(this).closest(".form__row--checkbox").hide();
                            } else {
                                $(this).closest(".form__row--checkbox").show();
                            }
                        })
                    } else {
                        if (isTransittedFromProductCalculator) {
                            $("#activity-levels-transitted").css("display", "none");
                            $("#activity-levels-transitted .form__row--checkbox").hide();
                        }
                    }
                }
            };
        });



        $(document).on("change", ".js-products", function (e) {
            $("#product-selector-validation").hide();
            $(".feeding-calculator__results-amount").addClass("is-disabled");
            $(".feeding-calculator__results-amount p.h2").text("0g");
            $(".feeding-calculator__results-amount p.label").text("Per day");

            $(".feeding-calculator__results-cost-item").addClass("is-disabled");
            $(".feeding-calculator__results-cost-item.js-cost-per-day p.h3").text("$0.00");
            $(".feeding-calculator__results-cost-item.js-cost-per-bag p.h3").text("$0.00");

            const isWetFoodProductChanged = $(this).attr("id") == "js-products-wet";
            const productImage = isWetFoodProductChanged ? $("#product-selected-image-wet") : $("#product-selected-image-dry");
            const isDryAndWetFood = $("#js-feeding-combination").val() === "dryandwet";
            const productId = $(this).val();
            if (productId == -1) {
                productImage.attr("src", "");
                if (!isDryAndWetFood) {
                    if (isCat) {
                        $(".js-cat-activity-level-section").css("display", "none");
                    }
                } else {
                    const isDryFoodSelected = $("#js-products-dry").val() != -1;
                    if (isCat) {
                        $(".js-cat-activity-level-section").css("display", isDryFoodSelected ? "block" : "none");
                    }
                }
            } else {
                if (isWetFoodProductChanged) {
                    $("#product-selector-validation-wet").css("display", "none");
                } else {
                    $("#product-selector-validation-dry").css("display", "none");
                }

                const imgSrc = $(this).find(":selected").data("product-selected-image");
                productImage.attr("src", imgSrc);

                let activityLevelsData = isDryAndWetFood ? $("#js-products-dry").find(":selected")?.data("activity-levels") ?? ""
                    : $(this).find(":selected")?.data("activity-levels") ?? "";

                if (!isStandAloneFeedingCalculator) {
                    const isOnDryFoodProductPage = feedingCalculatorSelector.data("isdryfoodproduct") && feedingCalculatorSelector.data("isdryfoodproduct").toLowerCase() === "true";

                    if (isDryAndWetFood) {
                        if (isCat) {
                            if (isOnDryFoodProductPage) {
                                activityLevelsData = feedingCalculatorSelector.data("foodproductactivitylevels");
                            } else {
                                activityLevelsData = $("#js-products-dry").find(":selected")?.data("activity-levels") ?? "";
                            }
                        }
                    } else {

                    }
                }

                if (isCat) {
                    updateActivityLevelDataForCat(activityLevelsData);
                }

                if (isDryAndWetFood && isWetFoodProductChanged) {
                    return;
                }
            };
        });

        $(document).on("change", "#js-feeding-combination", onFeedCombinationChanged);

        $(document).on("change", ".pet-activity-levels:visible input[type='radio']", function () {
            $(".js-pet-activity-validation").css("display", "none");
        })
    });

})(dailyFeedingCalculator);
